import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function UrgencyBar() {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const formatted = tomorrow.toLocaleDateString('es-MX', {
    day: 'numeric',
    month: 'long'
  });
  return <div className="fixed top-0 left-0 right-0 z-50 bg-surface-elevated border-b border-gold/30 animate-slide-down" data-id="element-261">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center text-center" data-id="element-262">
        <AlertCircleIcon className="w-4 h-4 text-gold mr-2 flex-shrink-0" data-id="element-263" />
        <p className="text-sm md:text-base font-body font-medium text-gray-200" data-id="element-264">
          <span className="text-gold font-bold" data-id="element-265">
            ¡OFERTA DE RE-LANZAMIENTO!
          </span>{' '}
          Disponible solo hasta el{' '}
          <span className="text-gold font-bold" data-id="element-266">{formatted}</span>. ⏳
        </p>
      </div>
    </div>;
}